import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight, Check } from "lucide-react";
import useSEO from "@/hooks/useSEO";
import PageHero from "@/components/common/PageHero";
import { Reveal, RevealGroup, RevealItem } from "@/components/common/Reveal";
import CTASection from "@/components/sections/CTASection";
import { SERVICES } from "@/data/site";

export default function Services() {
  useSEO({
    title: "Servicios — Automotriz, Industrial, Naval y Suministros",
    description:
      "Conoce los servicios de GEMA: mantenimiento automotriz, mantenimiento industrial, servicios navales y suministro técnico de repuestos certificados.",
    path: "/servicios",
  });

  return (
    <>
      <PageHero
        overline="Servicios"
        title="Soluciones técnicas para cada sector"
        subtitle="Ofrecemos servicios especializados agrupados en cuatro grandes áreas, respaldados por experiencia, personal calificado y repuestos certificados."
        image="https://images.unsplash.com/photo-1738918901587-41f3f3f88afd"
        crumbs={[{ label: "Servicios" }]}
      />

      <section className="bg-gema-black py-20 md:py-28">
        <div className="container-gema space-y-6">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Wrench;
            const reverse = i % 2 === 1;
            return (
              <Reveal key={s.slug}>
                <div className={`grid grid-cols-1 lg:grid-cols-2 border border-white/10 overflow-hidden ${reverse ? "lg:[direction:rtl]" : ""}`}>
                  <div className="relative h-[280px] lg:h-auto min-h-[320px] [direction:ltr]">
                    <img src={s.image} alt={s.name} className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" loading="lazy" />
                    <div className="absolute inset-0 bg-black/30" />
                  </div>
                  <div className="p-8 md:p-12 flex flex-col justify-center [direction:ltr]">
                    <div className="flex items-center gap-4">
                      <Icon className="h-9 w-9 text-gema-red" strokeWidth={1.5} />
                      <span className="font-mono text-xs text-white/40 tracking-widest">0{i + 1} // {s.name.toUpperCase()}</span>
                    </div>
                    <h2 className="font-heading font-black uppercase text-3xl text-white mt-6">{s.name}</h2>
                    <p className="text-white/60 mt-4 leading-relaxed">{s.short}</p>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-6">
                      {s.items.slice(0, 6).map((it) => (
                        <li key={it} className="flex items-start gap-2 text-white/70 text-sm">
                          <Check className="h-4 w-4 text-gema-red mt-0.5 shrink-0" /> {it}
                        </li>
                      ))}
                    </ul>
                    <Link to={`/servicios/${s.slug}`} data-testid={`service-detail-link-${s.slug}`} className="btn-primary mt-8 w-fit group">
                      Ver Servicio
                      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                    </Link>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <CTASection />
    </>
  );
}
